import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { healthRemove } from '../player.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Bleed extends Modifier {
  static readonly baseTitle = 'Bleed';
  static readonly baseText = 'Take 1 pure damage each time you are damaged, then fade.';
  static readonly baseIcon = 'blood';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Early;

  // Instance properties that can change
  title = Bleed.baseTitle;
  text = Bleed.baseText;
  icon = Bleed.baseIcon;
  tags: Array<ModifierTags> = [...Bleed.baseTags];
  priority = Bleed.basePriority;

  damageIn(damage: Damage) {
    const bleed: Damage = {
      value: 1,
      target: this.owner,
      source: this.owner,
      dice: [],
    };

    healthRemove(bleed);
    this.removeStacks(1);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Bleed, Bleed);
